export default __webpack_public_path__ + "static/media/Phil_Weiser.64ca9c63.jpg";